import React from 'react';
import { activityTypes } from '../../../../../helper/constants.helper';
import { Button, Rating } from '@mui/material';
import { Link } from 'react-router-dom';

const MeetingButtons = ({ historyItem }) => {
  return (
    <>
      {historyItem?.type === activityTypes.MEETING && historyItem?.meetingLink && (
        <Button
          target="_blank"
          href={historyItem.meetingLink}
          variant="contained"
          color="primary"
          size="small"
          fullWidth>
          Join meeting
        </Button>
      )}
      {historyItem?.type === activityTypes.MEETING && historyItem?.feedbackId && (
        <Link to={`/feedback/${historyItem?.feedbackId}`}>
          <Button
            color="primary"
            size="small"
            fullWidth
            style={{
              justifyContent: 'flex-start',
              textAlign: 'left'
            }}>
            {historyItem?.feedbackStars ? (
              <Rating
                name="feedback-stars"
                value={historyItem?.feedbackStars}
                size="small"
                readOnly
              />
            ) : (
              <span>Feedback</span>
            )}
          </Button>
        </Link>
      )}
    </>
  );
};

export default MeetingButtons;
